import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-auth-side',
  templateUrl: './auth-side-nav.component.html',
  styleUrls: ['./auth-side-nav.component.scss']
})
export class AuthSideNavComponent {

  showLogin = false;
}
